// LinkFragment.tsx (VERSIÓN CORREGIDA - misma lógica que LeftMenuSection)
import React from 'react'
import parse from 'html-react-parser'
import { Link, useParams } from 'react-router-dom'
import { usePublication } from '../../hooks/usePublication'
import { findTypeOption, typeLibro } from '../../interfaces/Publication'

interface LinkFragmentProps {
    idxSection: number
    idAnchor: string
    title: string
}

const LinkFragment = ({ idxSection, idAnchor, title }: LinkFragmentProps) => {
    const { publication } = usePublication()
    
    let { idRevista, idLibro } = useParams();
    const typeLibro: typeLibro = idLibro ? "libro" : "revista"
    const route = findTypeOption(typeLibro)?.route || ""

    const handleClick = (e: React.MouseEvent) => {
        
        // Cerrar menú en móviles
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        if (isMobile) {
            const menu = document.querySelector(".js-nav");
            menu?.classList.remove("expand");
        }
        
        // DISPARAR EVENTO EXACTAMENTE IGUAL QUE LeftMenuSection
        setTimeout(() => {
            window.dispatchEvent(
                new CustomEvent('scrollToAnchor', {
                    detail: { anchorName: idAnchor }
                })
            );
        }, 100);
    }

    return (
        <Link 
            to={`/${route}/${publication.id}/${idxSection}#${idAnchor}`}
            className="nav__link" 
            onClick={handleClick}
        >
            {parse(title)}
        </Link>
    )
}

export default LinkFragment